(function () {
  var KEY = 'thCatNav';
  var LEAVE_MS = 180;
  var ENTER_MS = 280;
  var WAIT_MAX_MS = 360;
  var FRESH_MS = 5000;

  function readState() {
    try {
      var data = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!data || typeof data.t !== 'number' || Date.now() - data.t > FRESH_MS) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeState(extra) {
    var payload = Object.assign({ t: Date.now(), left: 0 }, extra || {});
    try {
      sessionStorage.setItem(KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  if (readState()) {
    document.documentElement.classList.add('th-cat-enter');
  }

  window.__thCatRestoreTrack = function (track) {
    if (!track) return false;
    var data = readState();
    if (!data || typeof data.left !== 'number') return false;
    track.__veCatUserMoved = true;
    track.scrollLeft = data.left;
    return true;
  };

  function fadeIn() {
    var root = document.documentElement;
    if (!root.classList.contains('th-cat-enter')) return;

    requestAnimationFrame(function () {
      root.classList.add('th-cat-enter-ready');
    });

    setTimeout(function () {
      root.classList.remove('th-cat-enter', 'th-cat-enter-ready', 'th-cat-leave');
    }, ENTER_MS + 40);
  }

  function revealWhenReady() {
    if (!document.documentElement.classList.contains('th-cat-enter')) return;
    if (reducedMotion()) {
      document.documentElement.classList.remove('th-cat-enter', 'th-cat-enter-ready', 'th-cat-leave');
      return;
    }

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      fadeIn();
    }

    var imgs = document.querySelectorAll('.product-list img');
    var pending = 0;
    for (var i = 0; i < imgs.length && i < 4; i++) {
      if (imgs[i].complete) continue;
      pending += 1;
      imgs[i].addEventListener('load', function () {
        pending -= 1;
        if (pending <= 0) finish();
      }, { once: true });
      imgs[i].addEventListener('error', function () {
        pending -= 1;
        if (pending <= 0) finish();
      }, { once: true });
    }
    if (pending === 0) finish();
    setTimeout(finish, WAIT_MAX_MS);
  }

  function leaveThenGo(url, track) {
    writeState({ left: track ? track.scrollLeft : 0 });
    if (reducedMotion()) {
      location.assign(url);
      return;
    }
    document.documentElement.classList.add('th-cat-leave');
    setTimeout(function () {
      location.assign(url);
    }, LEAVE_MS);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var card = e.target.closest && e.target.closest('a.ve-category-nav__card');
    if (!card) return;

    var href = card.getAttribute('href');
    if (!href) return;

    var next;
    try {
      next = new URL(href, location.href);
    } catch (err) {
      return;
    }
    if (next.origin !== location.origin) return;
    if (next.pathname === location.pathname && next.search === location.search) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    document.querySelectorAll('.ve-category-nav__card.is-current').forEach(function (el) {
      el.classList.remove('is-current');
      el.removeAttribute('aria-current');
    });
    card.classList.add('is-current');
    card.setAttribute('aria-current', 'page');

    var nav = card.closest('[data-ve-category-nav]');
    var track = nav && nav.querySelector('[data-ve-cat-carousel]');
    leaveThenGo(next.href, track);
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.documentElement.classList.remove('th-cat-enter', 'th-cat-enter-ready', 'th-cat-leave');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealWhenReady);
  } else {
    revealWhenReady();
  }
})();
